// `/upload/review/:id` — старый адрес экрана проверки.
//
// ИСТОРИЯ, которую важно знать, иначе правка выглядит произвольной.
//
// В Sprint 4 проверка жила inline на Главной: `OnboardingRouter` подменял `/`
// экраном проверки, пока оставался хоть один непроверенный анализ. Этот маршрут
// существовал только для писем и внешних ссылок и был чистым редиректом на `/` —
// там человека и встречала нужная проверка.
//
// Дальше HEAL-44 завёл честный адрес `/uploads/:id/review`: открыв старый анализ
// из истории, человек правил и подтверждал совсем другой файл, потому что `/`
// показывала первый непроверенный, а не тот, который он открыл.
//
// А HEAL-46a D-18 убрал подмену Главной совсем — при пакете она превращалась в
// ловушку. После этого редирект на `/` стал вести в никуда: проверки там больше
// нет. Отсюда регрессия — из списка пакета клик по файлу возвращал на Главную.
//
// Теперь старый адрес ведёт туда же, куда все остальные пути, СОХРАНЯЯ номер
// анализа. Экран проверки один, и адрес у него один.

import { Redirect, useRoute } from 'wouter';
import { clearReviewOrigin } from '@/lib/uploadNav';

export function UploadReviewRedirect() {
  const [, params] = useRoute('/upload/review/:id');
  const uploadId = Number(params?.id);

  // Мусор в адресе — на Главную, а не белый экран.
  if (!Number.isInteger(uploadId) || uploadId <= 0) {
    return <Redirect to="/" />;
  }

  // Человек пришёл извне — из письма или по прямой ссылке. Признак «откуда» от
  // прошлого потока здесь врал бы, поэтому сбрасываем: «Вернусь позже» уведёт
  // на Главную, и это честно (круг ревью, находка 2).
  clearReviewOrigin();

  return <Redirect to={`/uploads/${uploadId}/review`} replace />;
}
